import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() { }
  // Dans votre composant ou service
  requestPermission() {
    if ('Notification' in window) {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          console.log('Notification permission granted.');
        } else {
          console.log('Notification permission denied.');
        }
      });
    } else {
      console.log("Notification indisponible")
    }
  }
  // Dans votre composant ou service
  showNotification(title: string, body: string) {
    // this.requestPermission()
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body: body,
        icon: 'assets/minoterie_logo.png' // Optionnel, chemin vers une icône
      });

      // Ajouter un son
      const audio = new Audio('assets/not.wav');
      audio.play();
    }
  }


}
